import * as React from 'react';
import { actions } from '../../../../ducks/MessageForm';
import { SimpleFormLabel, SimpleFormCheckbox } from '../../../../lib/components/SimpleForm';
import { getDispatch } from '../../../../lib/dispatchExporter';
import I18n from '../../../../lib/i18n';
import MessageDetail from '../../../../models/MessageDetail';
import Movie from '../../../../models/Movie';
import InputForm from './InputForm';
import notify from '../../../../lib/notify';

interface IProps {
  label: string;
  parentFormName: string;
  parentResource: MessageDetail;
  helpMessage: string;
  index: number;
  semanticsVersion: number;
}
interface IState {
  movieUrl: string;
}
export default class ListMovieForm extends React.PureComponent<IProps, IState> {
  private dispatch = getDispatch();

  constructor(props: IProps) {
    super(props);
    this.state = {
      movieUrl: '',
    };
  }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ movieUrl: e.target.value });
  }

  public handleClick = () => {
    const { movieUrl } = this.state;
    const { parentResource } = this.props;
    const updateKey = this.getUpdateKey();
    const movieIndex = parentResource.list_movie_attributes.movies.size - 1;

    // メタID英数字64桁しか受け付けない
    if (!movieUrl.match(/^[0-9a-f]{64}$/)) {
      notify({
        title: '',
        message: I18n.t('activerecord.errors.message_detail.invalid_movie_url'),
        type: 'danger'
      });
      return false;
    }

    if (!parentResource.list_movie_attributes.movies.filter(e => !e._destroy).isEmpty()) {
      this.dispatch(actions.deleteMovie({ key: updateKey, index: movieIndex }));
      this.dispatch(actions.addMovie({ key: updateKey, movieUrl, isQualityFirst: false }));
    } else {
      this.dispatch(actions.addMovie({ key: updateKey, movieUrl, isQualityFirst: false }));
    }
    this.setState({ movieUrl: '' });
  }

  public getUpdateKey = () => {
    const { parentFormName } = this.props;
    return(
      ['messageDetails'].concat(parentFormName.replace(/]/g, '').split('[').slice(2)).concat(['list_movie_attributes']));
  }

  public renderListMovieCard = () => {
    const { parentResource, parentFormName } = this.props;
    const { list_movie_attributes: listMovie } = parentResource;
    const updateKey = this.getUpdateKey();

    return listMovie.movies.map((movie: Movie, index: number) => {
      const formName = `${parentFormName}[list_movie_attributes][${index}]`;
      const relationFormName = `${parentFormName}[list_movie_relation_attributes]`;
      return(
        <InputForm key={index} {...{ movie, updateKey, movieIndex: index, formName, relationFormName }}/>
      );
    });
  }

  public render() {
    const { label, parentResource, helpMessage, index, semanticsVersion } = this.props;
    const { movieUrl } = this.state;
    const { list_movie_attributes: listMovie } = parentResource;
    const errorMessage = listMovie ? listMovie.errors : [] ;
    const useMainVideo = parentResource.use_main_movie_as_list_movie !== false;

    // セマンティックスバージョン12以上の場合「メイン動画と同じ動画を利用する」というチェックボックスUIを表示
    return (
      <div style={{ marginBottom: '25px' }}>
        <SimpleFormLabel
          label={label}
          errorMessage={Object.values(errorMessage)}
          popoverText={I18n.t('message_details.tooltips.list_movie')}
        >
          {semanticsVersion >= 12 ? (
            <>
              <p className="help-block" style={{ whiteSpace: 'pre-line' }}>
                {I18n.t('activerecord.hints.message_detail.list_movie_v12_or_later')}
              </p>
              <SimpleFormCheckbox
                name={`message[message_details_attributes][${index}][use_main_movie_as_list_movie]`}
                label={I18n.t('message_details.form.use_main_movie_as_list_movie')}
                checked={useMainVideo}
                onChange={(e) => {
                  const checked = e.target.checked;
                  this.dispatch(actions.updateFormStore({
                    key: ['messageDetails', index, 'use_main_movie_as_list_movie'],
                    value: checked,
                  }));
                }}
              />
              {!useMainVideo && (
                <div className="row">
                  <div className="col-md-6">
                    <input type="text" className="form-control" value={movieUrl} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-6" style={{ marginBottom: '10px' }}>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.handleClick}
                      disabled={!movieUrl}
                    >
                      {I18n.t('common.action.update')}
                    </button>
                  </div>
                </div>
              )}
            </>
          ) : (
            // v11以下の場合
            <div className="row">
              <div className="col-md-6">
                <input type="text" className="form-control" value={movieUrl} onChange={this.handleChange} />
              </div>
              <div className="col-md-6" style={{ marginBottom: '10px' }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleClick}
                  disabled={!movieUrl}
                >
                  {I18n.t('common.action.update')}
                </button>
              </div>
            </div>
          )}
        </SimpleFormLabel>
        {semanticsVersion < 12 && <p className="help-block">{helpMessage}</p>}
        { this.renderListMovieCard()}
      </div>
    );
  }
}
